export const downloads = {
  seo: {
    title: 'Downloads | Bistroo',
    description: 'Download de Bistroo Manager app voor iOS en Android. Beheer je restaurant eenvoudig vanaf je smartphone.',
  },
  title: 'Downloads',
  subtext: 'Op deze pagina vind je een overzicht van alle Bistroo Manager versies ',
  operating_system: {
    win: 'Windows',
    mac_os: 'Mac OSX',
  },
  supported_subversions: {
    win: 'Windows 7, Windows 8, Windows 10, Windows 11',
    mac_os: 'Ventura, Monterey, Big Sur',
  },

  btn_text: 'Download',

  latest_version_text:
    'Download de laatste versie van Bistroo Manager voor {os}. Op dit moment is dit versie {version}',

  previous_versions_title: 'Vorige versies',
  previous_versions_subtext:
    'Op deze pagina vind je een overzicht van alle Bistroo Manager versies ',
}
